<template>
  <div id="xit-flow-builder" class="xit-flow-builder">
    <div
      ref="xitFlowBuilder"
      id="xit-fb-droppable"
    ></div>
    
    <action-buttons />
    <dock-menu-card :faviconSrc="getFavicon()" />
    <hover-node-card />

  </div>
</template>

<script>
import { App } from '../App.js'
import moduleConfigs from '../config/modules'

import DockMenuCard from './dock/DockMenuCard'
import ActionButtons from './editor/ActionButtons'
import HoverNodeCard from './editor/HoverNodeCard'
import CONST_COMPONENT from '../const/component'
import {
  alertBeforeClosingBrowser,
  setDefaultComponentBasedOnUrlParams,
} from '../functions/utils'

export default {
  name: 'Flow',
  components: {
    'dock-menu-card': DockMenuCard,
    'action-buttons': ActionButtons,
    'hover-node-card': HoverNodeCard,
  },

  methods: {
    getFavicon() {
      return window.xitFlowBuilderData.base_url 
        ? window.xitFlowBuilderData.base_url + 'assets/img/favicon.png'
        : null
    }
  },
  
  mounted() {
    window.hasXitFlowBuilderData = false
    var data = window.xitFlowBuilderData.data || null
    var builder_id = window.xitFlowBuilderData.builder_id || null
    
    // Inits application
    const app = new App(this.$refs.xitFlowBuilder, moduleConfigs, builder_id)

    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    
    if (data) {
      app.fromJSON(data)
      setTimeout(function() {
        App.editor.view.updateConnections({ node: App.getDefaultComponent() })
      }, 100)
    } else if (Object.keys(params).length > 0) {
      if (params.type && App.config.defaultComponentMappingTypeToClass[params.type]) {
        setDefaultComponentBasedOnUrlParams(params)
      } else {
        app.setDefaultComponent(CONST_COMPONENT.POSTBACK, [-450, -50])
      }
      setTimeout(function() {
        App.editor.view.updateConnections({ node: App.getDefaultComponent() })
      }, 100)
    } else {
      app.setDefaultComponent(CONST_COMPONENT.POSTBACK, [-450, -50])
    }

    App.editor.view.area.zoom(1.15,80);

    // Makes flow builder area droppable
    $('#xit-fb-droppable').droppable({
      tolerance: "pointer",
      drop: async function(event, ui) {
        await App.handleComponentCreate(event, ui)
      },
    })

    // Inits bootstrap tooltip
    $('[data-toggle="tooltip"]').tooltip()

    if (! App.isDevMode) {
      alertBeforeClosingBrowser()
    }
  },

  beforeDestroy() { // eslint-disable-line
    const xitFbDroppableElement = $('#xit-fb-droppable')
    const isxitFbDroppableDroppable = xitFbDroppableElement.hasClass('ui-droppable')
    
    if (isxitFbDroppableDroppable) {
      xitFbDroppableElement.droppable('destroy')
    }

    const tooltip = $('[data-toggle="tooltip"]')
    if (tooltip) {
      tooltip.tooltip('dispose')
    }
  }
}
</script>